// import components from './components'
// import { loadIcons } from 'nette-base-module/js/components/AwIcon'
// import useStore from './store'
import './views'
import './store'
import loadComponents from './components'
import loadDirectives from './directives'

export default function install (vueApp, context) {
  loadComponents(vueApp, context)
  loadDirectives(vueApp, context)
}